module.exports = __webpack_public_path__ + "img/painpoint1.d3ea37b5.png";